export default "__VITE_ASSET__CCbSJ6ad__"